import React from 'react'
import Section1 from '../ComponentsPage/JobOpportunity/Section1'
import Section2 from '../ComponentsPage/JobOpportunity/Section2'
import Section3 from '../ComponentsPage/JobOpportunity/Section3'
import Career from '../ComponentsPage/Banner/Career'
const JobOpportunity = () => {
  return (
    <div>
      <Career/>
      <Section1/>
      <Section2/>
      <Section3/>
    </div>
  )
}

export default JobOpportunity
